module.exports = __webpack_public_path__ + "img/megan_dressed.192ed514.jpg";